import { Component, OnInit } from '@angular/core';
import { ActionSheetController, ToastController } from '@ionic/angular';
import { Router } from "@angular/router";
import { TranslateService } from '@ngx-translate/core';
import { SigninService } from '../../signin/signin.service';
import { DataManagementService } from '../../pages/data-management/data-management.service';
import { ViewChild, HostListener, ElementRef } from '@angular/core';
import { IonFab } from '@ionic/angular';
import { FloatingMenuService } from './floating-menu.service';
import { ThemeService } from '../theme/theme.service';

@Component({
  selector: 'app-floating-menu',
  templateUrl: './floating-menu.component.html',
  styleUrls: ['./floating-menu.component.scss'],
})
export class FloatingMenuComponent implements OnInit {

  @ViewChild('fab', { static: false }) fab: IonFab;

  constructor(
    public signinService: SigninService,
    public actionSheetCtrl: ActionSheetController,
    private router: Router,
    public translate: TranslateService,
    private toastController: ToastController,
    public dataManangementService: DataManagementService,
    private menuService: FloatingMenuService,
    private eRef: ElementRef,
    public themeService: ThemeService
  ) { }

  @HostListener('document:mousedown', ['$event'])
  clickout(event) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      if (this.fab) this.fab.close();
    }
  }

  ngOnInit() {
    this.menuService.activeMenu$.subscribe(menuId => {
      if (menuId !== 'user' && this.fab) {
        this.fab.close();
      }
    });
  }

  onFabClick() {
    this.menuService.setActiveMenu('user');
  }

  toggleTheme() {
    this.themeService.toggleTheme();
  }

  openSettings() {
    this.router.navigate(['settings']);
  }

  async logoutconfirm() {
    const lang = localStorage.getItem('lang') || 'fr';
    let actionSheet: HTMLIonActionSheetElement;

    const buttons = [
      {
        text: lang === 'fr' ? 'Annuler' : lang === 'en' ? 'Cancel' : 'إلغاء',
        role: 'cancel',
        handler: () => { }
      },
      {
        text: lang === 'fr' ? 'Déconnexion' : lang === 'en' ? 'Logout' : 'تسجيل الخروج',
        cssClass: 'Logout',
        handler: () => {
          this.logout();
        }
      }
    ];

    actionSheet = await this.actionSheetCtrl.create({
      header: lang === 'fr' ? 'Souhaitez-vous vraiment vous déconnecter?' :
        lang === 'en' ? 'Are you sure you want to log out?' :
          'هل أنت متأكد أنك تريد تسجيل الخروج؟',
      buttons
    });

    await actionSheet.present();
  }

  logout() {
    // Clear local data
    this.dataManangementService.pointInterests = [];
    this.dataManangementService.selectedGroup = null;
    this.dataManangementService.selectedVehicule = null;
    this.dataManangementService.groups = [];

    // Clear localStorage
    localStorage.removeItem("id_token");
    localStorage.removeItem("currentUser");
    localStorage.removeItem("groups");
    localStorage.removeItem("pointInterests");

    // Set auth state to false
    this.signinService.authState = false;

    // Navigate to signin
    this.router.navigate(['signin']);
  }

  async chooseLanguge() {
    const actionSheet = await this.actionSheetCtrl.create({
      header: this.translate.instant('HEADER.language'),
      cssClass: 'language-action-sheet',
      buttons: [
        {
          text: this.translate.instant('APP.CANCEL'),
          role: 'cancel',
        },
        {
          text: this.translate.instant('COMMON.english'),
          handler: () => this.switchLanguage('en'),
        },
        {
          text: this.translate.instant('COMMON.french'),
          handler: () => this.switchLanguage('fr'),
        },
        {
          text: this.translate.instant('COMMON.arabic'),
          handler: () => this.switchLanguage('ar'),
        },
      ],
    });

    await actionSheet.present();
  }

  switchLanguage(lang: string) {
    this.translate.use(lang);
    this.translate.currentLang = lang;
    localStorage.setItem('lang', lang);
    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = lang;

    let message = '';
    switch (lang) {
      case 'fr':
        message = this.translate.instant('COMMON.languageChangedFr');
        break;
      case 'en':
        message = this.translate.instant('COMMON.languageChangedEn');
        break;
      case 'ar':
        message = this.translate.instant('COMMON.languageChangedAr');
        break;
    }

    this.showLanguageConfirmation(message);
  }

  async showLanguageConfirmation(message: string) {
    const toast = await this.toastController.create({
      message,
      duration: 2000,
      position: 'top',
      cssClass: 'language-toast'
    });

    toast.present();
  }
}
